import React from 'react';
import VoiceStatusIndicator from './VoiceStatusIndicator';

/**
 * PageHeader - Header section for the Communications page
 */
const PageHeader = ({
  title = 'COMMUNICATIONS',
  subtitle = '',
  voiceReady = false,
  className = ''
}) => {
  return (
    <div className={`mb-2 md:mb-4 flex-shrink-0 ${className}`}>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-1 md:gap-2">
        <div>
          <h1 className="text-lg sm:text-2xl md:text-3xl font-bold mokoto-font">{title}</h1>
          {subtitle && <p className="text-gray-400 text-[10px] md:text-sm">{subtitle}</p>}
        </div>
        <VoiceStatusIndicator isReady={voiceReady} />
      </div>
    </div>
  );
};

export default PageHeader;
